Vue.component('common-popup', {
  data: function () {
    return {
      isShow: this.visible,
      isMobile: window.plugin.isMobile(),
      fadeClass: ''
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: ''
    }
  },
  watch: {
    visible: {
      handler(val) {
        let index = document.body.getAttribute("data-index") || 0
        if (val) {
          this.fadeClass = 'fade-enter'
          this.isShow = val
          document.body.setAttribute("data-index", ++index); //记录body中有几个弹窗
          document.body.style.overflow = 'hidden'
          !this.isMobile && (document.body.style.paddingRight = '17px')
        } else {
          this.fadeClass = 'fade-leave'
          document.body.setAttribute("data-index", --index); //记录body中有几个弹窗
          setTimeout(() => {
            this.isShow = val
            index == 0 && (document.body.style = {})
          }, 400)
        }
      },
      // immediate: true
    }
  },
  created() {
    if (this.visible) {
      let index = document.body.getAttribute("data-index") || 0
      document.body.setAttribute("data-index", ++index);
    }
  },
  template: `
    <transition>
      <div class="popup-wrapper" v-show="isShow" >
          <div :class="['popup-content', fadeClass]" ref="dialog">
            <slot name="content">
            </slot>
          </div>
          <div class="popup-modal"></div>
      </div>
    </transition>`
})